import { useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { FIELD_LABELS } from '../../lib/importAPI';

export const MappingStep = ({ up, columns, setColumns, mappings, onSaveMapping, opts, setOpts, onLoadMapping }) => {
  const [name, setName] = useState('');
  const set = (f, h) => setColumns({ ...columns, [f]: h || undefined });
  return (
    <div className="space-y-4" data-testid="import-mapping">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="text-muted-foreground">{up.row_count} rows · delimiter “{up.delimiter === '\t' ? 'tab' : up.delimiter}” · {up.encoding}</span>
        {up.preset && <span className="rounded bg-emerald-50 px-2 py-0.5 text-xs text-emerald-800" data-testid="import-preset-badge">Preset detected: {up.preset.name}</span>}
        {up.ignored_columns?.length > 0 && <span className="text-xs text-muted-foreground">Ignored this round: {up.ignored_columns.join(', ')}</span>}
        {mappings.length > 0 && (
          <select className="h-8 rounded border bg-background px-2 text-sm" defaultValue="" onChange={(e) => { const m = mappings.find((x) => x.id === e.target.value); if (m) onLoadMapping(m); }} data-testid="import-load-mapping">
            <option value="">Load mapping…</option>
            {mappings.map((m) => <option key={m.id} value={m.id}>{m.builtin ? `${m.name} (built-in)` : m.name}</option>)}
          </select>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-4 text-xs">
        <label className="flex items-center gap-2"><input type="checkbox" checked={!!opts.split_names} onChange={(e) => setOpts({ ...opts, split_names: e.target.checked })} data-testid="import-split-names" />Split “SURNAME, First” into first / last name (individuals and sole traders)</label>
        <label className="flex items-center gap-2">Blank business structure:
          <select className="h-7 rounded border bg-background px-2" value={opts.blank_entity || ''} onChange={(e) => setOpts({ ...opts, blank_entity: e.target.value || null })} data-testid="import-blank-entity">
            <option value="individual">Import as Individual (with warning)</option><option value="skip">Skip the row</option><option value="">Mark invalid until mapped</option>
          </select>
        </label>
      </div>
      <div className="grid md:grid-cols-3 gap-2">
        {Object.entries(FIELD_LABELS).map(([f, label]) => (
          <label key={f} className="flex items-center gap-2 text-xs">
            <span className="w-36 shrink-0">{label}</span>
            <select className="h-8 flex-1 rounded border bg-background px-2" value={columns[f] || ''} onChange={(e) => set(f, e.target.value)} data-testid={`map-${f}`}>
              <option value="">—</option>
              {up.headers.map((h) => <option key={h} value={h}>{h}</option>)}
            </select>
          </label>
        ))}
      </div>
      <div className="overflow-x-auto rounded border">
        <table className="text-xs w-full" data-testid="import-sample">
          <thead><tr>{up.headers.map((h) => <th key={h} className="px-2 py-1 text-left bg-muted/50 whitespace-nowrap">{h}</th>)}</tr></thead>
          <tbody>{up.sample.map((r, i) => <tr key={i}>{up.headers.map((h) => <td key={h} className="px-2 py-1 border-t whitespace-nowrap">{r[h]}</td>)}</tr>)}</tbody>
        </table>
      </div>
      <div className="flex items-center gap-2">
        <Input className="h-8 w-56" placeholder="Save mapping as…" value={name} onChange={(e) => setName(e.target.value)} data-testid="import-mapping-name" />
        <Button size="sm" variant="outline" disabled={name.trim().length < 2} onClick={() => onSaveMapping(name.trim())} data-testid="import-save-mapping">Save mapping</Button>
      </div>
    </div>
  );
};
